/**
 * 智能客服拨号号码 新增/编辑/详情弹窗
 */
import React, { useEffect, useState } from 'react';
import { Form, Input, InputNumber, message, Modal, Switch } from 'antd';
import {
  upsertCccCallerNumberRequest,
  CccCallerNumber
} from '@/service/smartCustomerServiceNumber';

interface OperateModalProps {
  type: string; // 操作类型: add | edit | detail
  data?: CccCallerNumber; // 编辑/详情时的数据
  closeModal: () => void; // 关闭弹窗的方法
  reloadData: () => void; // 保存成功后重新获取数据的方法
}

const OperateModal = (props: OperateModalProps) => {
  const { type, data, closeModal, reloadData } = props;
  const [form] = Form.useForm();
  const [submitLoading, setSubmitLoading] = useState(false); // 提交的loading

  // 编辑/详情时赋值
  useEffect(() => {
    if (['edit', 'detail'].includes(type) && data) {
      form.setFieldsValue({
        id: data.id,
        aiAgentId: data.aiAgentId,
        name: data.name,
        callers: data.callers,
        tries: data.tries,
        strategyKey: data.strategyKey,
        status: data.status === 1
      });
    } else {
      // 新增时默认启用
      form.setFieldsValue({ status: 1 });
    }
  }, []);

  // 保存
  const submit = async (values: any) => {
    console.log('values', values);
    const params: any = {
      callers: values.callers?.trim(),
      name: values.name?.trim(),
      aiAgentId: values.aiAgentId,
      tries: values.tries,
      strategyKey: values.strategyKey,
      status: values.status ? 1 : 0,
    };
    if (type === 'edit' && data) {
      params.id = data.id;
    }
    try {
      setSubmitLoading(true);
      const res = await upsertCccCallerNumberRequest(params);
      setSubmitLoading(false);
      if (res.data?.code === 0) {
        message.success(type === 'edit' ? '编辑成功' : '新增成功');
        closeModal();
        reloadData();
      } else {
        message.error(res.data?.msg || '保存失败');
      }
    } catch (error) {
      setSubmitLoading(false);
    }
  };

  return (
    <Modal
      title={
        type === 'detail'
          ? '智能体详情'
          : type === 'add'
          ? '新建智能体'
          : '编辑智能体'
      }
      open
      onCancel={closeModal}
      onOk={() => form.submit()}
      centered
      maskClosable={false}
      okButtonProps={{
        loading: submitLoading,
        style: type === 'detail' ? { display: 'none' } : {}
      }}
    >
      <Form
        form={form}
        autoComplete="off"
        onFinish={submit}
        layout="vertical"
        disabled={type === 'detail'}
      >

        <Form.Item label="智能体id" name="aiAgentId">
            <Input
              placeholder="请输入腾讯平台的智能体id"
              maxLength={20}
            />
        </Form.Item>
        <Form.Item label="智能体名称" name="name"
          rules={[ { required: true, message: '请输入智能体名称' },]}>
            <Input
              placeholder="请输入智能体名称"
              maxLength={10}
            />
        </Form.Item>
        <Form.Item
          label="主叫号码"
          name="callers"
          rules={[
            { required: true, message: '请输入主叫号码' },
          ]}
        >
          <Input placeholder="请输入主叫号码，多个号码中间使用英文逗号分隔" maxLength={100} />
        </Form.Item>
          <Form.Item
          label="重试次数"
          name="tries"
          rules={[
            { required: true, message: '请输入重试次数' },
          ]}
        >
          <InputNumber placeholder="请输入重试次数" min={0} max={10} />
        </Form.Item>
        <Form.Item label="策略标识" name="strategyKey">
          <Input placeholder="请输入策略标识" maxLength={20} />
        </Form.Item>
        <Form.Item
          label="状态"
          name="status"
          valuePropName="checked"
        >
          <Switch
            checkedChildren="启用"
            unCheckedChildren="禁用"
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default OperateModal;
